import React, { RefObject } from "react";
import { StudyModel } from "../Models/StudyModel";

import { InfoBox } from "../Components/InfoBox";
import { InputItem } from "../Components/InputItem";
import { DataHelper } from "../Helpers/DataHelper";
import { ErrorWindow } from "../Components/ErrorWindow";
import MultiFileBrowser from "../Components/MultiFileBrowser";
import { PiPlus } from "react-icons/pi";
import { PiTrash } from "react-icons/pi";
import { LabelModel } from "../Models/LabelModel";
import { studyTypeOptions } from "../Helpers/SharedClasses";
import { CollapsibleSection } from "../Components/CollapsibleSection";
import GaugeTile from "../Components/GaugeTile";

export class AddStudyWindow extends React.Component<
    { studies: StudyModel[], selectedStudy: StudyModel, dataClient: DataHelper, idOptions: string[]},
    {

        changeStudy: StudyModel,
        workflowProtocolSteps: string[],
        advancedSettingsOpen: boolean,        


    }
> {
    fileBrowserMulti: RefObject<MultiFileBrowser>;
    infoBox: RefObject<InfoBox>;
    errorWindow: RefObject<ErrorWindow>;
    DFGaugeRef: RefObject<GaugeTile>;
    BFGaugeRef: RefObject<GaugeTile>;
    PIGaugeRef: RefObject<GaugeTile>;
    MEANGaugeRef: RefObject<GaugeTile>;
    ACIGaugeRef: RefObject<GaugeTile>;
    constructor(props: any) {
        super(props);
        this.fileBrowserMulti = React.createRef();
        this.infoBox = React.createRef();
        this.errorWindow = React.createRef();
        this.DFGaugeRef = React.createRef();
        this.PIGaugeRef = React.createRef();
        this.MEANGaugeRef = React.createRef();
        this.ACIGaugeRef = React.createRef();
        this.BFGaugeRef = React.createRef();
        this.state = {
            changeStudy: {
                index: props.selectedStudy.index,
                id: props.selectedStudy.id,
                idFieldForStudy: props.selectedStudy.idFieldForStudy,
                allowPersonalData: props.selectedStudy.allowPersonalData,
                allowFullDateOnly: props.selectedStudy.allowFullDateOnly,
                name: props.selectedStudy.name,
                description: props.selectedStudy.description,
                startdate: props.selectedStudy.startdate,
                expectedProcedures: props.selectedStudy.expectedProcedures,
                expectedHospitals: props.selectedStudy.expectedHospitals,
                protocolSteps: props.selectedStudy.protocolSteps,
                workflowFilename: props.selectedStudy.workflowFilename,
                lowerReferenceValue: props.selectedStudy.lowerReferenceValue,
                upperReferenceValue: props.selectedStudy.upperReferenceValue,
                labelTypes: props.selectedStudy.labelTypes,
                suggestedLabels: props.selectedStudy.suggestedLabels,
                exportEnabled: props.selectedStudy.exportEnabled,
                curveEvalEnabled: props.selectedStudy.curveEvalEnabled,
                lastUpdated: props.selectedStudy.lastUpdated,
                procedures: props.selectedStudy.procedures,
                measurements: props.selectedStudy.measurements,
                flowNum: props.selectedStudy.flowNum,
                ecgNum: props.selectedStudy.ecgNum,
                studyType: props.selectedStudy.studyType,
                imagingNum: props.selectedStudy.imagingNum,
                noLabelNum: props.selectedStudy.noLabelNum,
                encryptionEnabled: props.selectedStudy.encryptionEnabled,
                defaultView: props.selectedStudy.defaultView,
                includeSurgeon: props.selectedStudy.includeSurgeon,
                includeProject: props.selectedStudy.includeProject,
                calculateBMI: props.selectedStudy.calculateBMI,
                dfUpperReferenceValue: props.selectedStudy.dfUpperReferenceValue,
                dfLowerReferenceValue: props.selectedStudy.dfLowerReferenceValue,
                piUpperReferenceValue: props.selectedStudy.piUpperReferenceValue,
                piLowerReferenceValue: props.selectedStudy.piLowerReferenceValue,
                aciUpperReferenceValue: props.selectedStudy.aciUpperReferenceValue,
                aciLowerReferenceValue: props.selectedStudy.aciLowerReferenceValue,
                bfUpperReferenceValue: props.selectedStudy.bfUpperReferenceValue,
                bfLowerReferenceValue: props.selectedStudy.bfLowerReferenceValue,
                meanGoodColor: props.selectedStudy.meanGoodColor,
                meanBadColor: props.selectedStudy.meanBadColor,
                meanWorstColor: props.selectedStudy.meanWorstColor,
                dfGoodColor: props.selectedStudy.dfGoodColor,
                dfBadColor: props.selectedStudy.dfBadColor,
                dfWorstColor: props.selectedStudy.dfWorstColor,
                piGoodColor: props.selectedStudy.piGoodColor,
                piBadColor: props.selectedStudy.piBadColor,
                piWorstColor: props.selectedStudy.piWorstColor,
                aciGoodColor: props.selectedStudy.aciGoodColor,
                aciBadColor: props.selectedStudy.aciBadColor,
                aciWorstColor: props.selectedStudy.aciWorstColor,
                bfGoodColor: props.selectedStudy.bfGoodColor,
                bfBadColor: props.selectedStudy.bfBadColor,
                bfWorstColor: props.selectedStudy.bfWorstColor,
            },
            workflowProtocolSteps: [],
            advancedSettingsOpen: false,

        };

    }

    componentDidMount() {
        console.log("AddStudyWindow mounted");
    }

    onInputItemchanged = (name: string, value: any) => {
        if(name ==="allowPersonalData" && value ===false){
            this.setState(prevState => ({

                changeStudy: {
                  ...prevState.changeStudy,
                  encryptionEnabled: false
                }
              }));
        }
       
        this.setState(prevState=>(
            {
                changeStudy: {
                    ...prevState.changeStudy,
                    [name]: value
                }
            }));
    }



    onDropdownChanged = (name: string, value: string) => {
        let today = new Date();

        if (value === "Add New Study") {
            this.setState({
                changeStudy: {
                    index: 0,
                    id: "-1",
                    idFieldForStudy:this.props.idOptions[0],
                    allowPersonalData: false,
                    allowFullDateOnly: false,
                    name: "",
                    description: "",
                    startdate: today,
                    expectedProcedures: 0,
                    expectedHospitals: 0,
                    protocolSteps: [],
                    workflowFilename: "",
                    lowerReferenceValue: 0,
                    upperReferenceValue: 0,
                    labelTypes:[],
                    suggestedLabels:[],
                    exportEnabled: false,
                    curveEvalEnabled:false,
                    encryptionEnabled: false,
                    procedures: 0,
                    measurements: 0,
                    flowNum:  0,
                    imagingNum: 0,
                    ecgNum: 0,
                    noLabelNum:  0,
                    lastUpdated:  today,
                    studyType: "None",
                    defaultView: "Intui",
                    includeSurgeon: false,
                    includeProject: false,
                    calculateBMI: true,
                    aciLowerReferenceValue: 0,
                    aciUpperReferenceValue: 0,
                    piLowerReferenceValue: 0,
                    piUpperReferenceValue: 0,
                    bfLowerReferenceValue: 0,
                    bfUpperReferenceValue: 0,
                    dfLowerReferenceValue: 0,
                    dfUpperReferenceValue: 0,
                    bfGoodColor: "var(--GreenApple)",
                    bfBadColor: "var(--BananaClan)",
                    bfWorstColor: "var(--BananaClan)",
                    meanGoodColor: "var(--BernRed)",
                    meanBadColor: "var(--BananaClan)",
                    meanWorstColor: "var(--GreenApple)",
                    dfGoodColor: "var(--GreenApple)",
                    dfBadColor: "var(--GreenApple)",
                    dfWorstColor: "var(--BananaClan)",
                    piGoodColor: "var(--GreenApple)",
                    piBadColor: "var(--BananaClan)",
                    piWorstColor: "var(--BernRed)",
                    aciGoodColor: "var(--BernRed)",
                    aciBadColor: "var(--BananaClan)",
                    aciWorstColor: "var(--GreenApple)"
                }
            })

        }
        else {
            let study = this.props.studies.find(study => study.name === value);
            this.setState({ changeStudy: study as StudyModel } )
        
        }

    }
    onIdFieldDropdownChanged = (name: string, value: string) => {
        this.setState(prevState => ({
            changeStudy: {
                ...prevState.changeStudy,
                idFieldForStudy: value
            }
        }));
    }
    onUploadConfirmed = async (dataOut: string) => {
        if (dataOut) {
            let workflowModelParsed = JSON.parse(dataOut);
            let filename = workflowModelParsed.filename;
            this.setState(prevState =>({
                changeStudy: {
                    ...prevState.changeStudy,
                    protocolSteps: workflowModelParsed.protocolSteps,
                    workflowFilename: filename,
                },
            }))
        }
    }

    calculateGaugeRanges(min:number, max:number, defaultMin = 0, defaultMax = 100) {
        const actualMin = min ?? defaultMin;
        const actualMax = max ?? defaultMax;
        
        const isRangeWideEnoughForGaps = (actualMax - actualMin) >= 2;
        const diff = actualMax > actualMin ? actualMax - actualMin : defaultMax;

        
        let calculatedBadRange;

        //gap the ranges for general useses to avoid overlapping zones
        if (isRangeWideEnoughForGaps) {
            calculatedBadRange = {
                min: actualMin + 1,
                max: actualMax - 1
            };
        } else {
            // Fallback for too narrow ranges
            calculatedBadRange = {
                min: actualMin,
                max: actualMax
            };
        }
    
        return {
          goodRange: { 
            min: Math.max(0, actualMin - diff), 
            max: actualMin 
          },
          badRange: calculatedBadRange,
          worstRange: { 
            min: actualMax, 
            max: actualMax + diff 
          }
        };
      }


      render() {
        let gaugeRangesDF = this.calculateGaugeRanges(this.state.changeStudy.dfLowerReferenceValue as number, this.state.changeStudy.dfUpperReferenceValue as number);
        let gaugeRangesPI = this.calculateGaugeRanges(this.state.changeStudy.piLowerReferenceValue as number, this.state.changeStudy.piUpperReferenceValue as number);
        let gaugeRangesMEAN = this.calculateGaugeRanges(this.state.changeStudy.lowerReferenceValue as number, this.state.changeStudy.upperReferenceValue as number);
        let gaugeRangesACI = this.calculateGaugeRanges(this.state.changeStudy.aciLowerReferenceValue as number, this.state.changeStudy.aciUpperReferenceValue as number);
        let gaugeRangesBF = this.calculateGaugeRanges(this.state.changeStudy.bfLowerReferenceValue as number, this.state.changeStudy.bfUpperReferenceValue as number);
    
        let collapsableGaugeAdjust = <CollapsibleSection title="Reference Values" defaultOpen={false}>
    
            <GaugeTile
                ref={this.DFGaugeRef}
                title="DF"
                value={gaugeRangesDF.goodRange.max + gaugeRangesDF.badRange.min / 2} // Example value
                context="Dashboard"
                enableColouring={true}
                valueStale={false}
                subValue={0}
                subValueUom=""
                uom="%"
                includeSubValue={false}
                defaultColor="tile-no-data"
                maxValue={1000}
                includeEdit={false}
                setRefValueMode={true}
                {...gaugeRangesDF}
                wideTile={false}
                expanded={true}
                referenceValueStyle="Bar"
                tileClicked={() => { console.log('Tile clicked') }}
                tileValueChanged={() => {
                    console.log('Value changed')
                }}
                onConfigChanged={(config) => {
                    let changeStudyIn = { ...this.state.changeStudy };
                    if (config.goodColor) changeStudyIn.dfGoodColor = config.goodColor;
                    if (config.badColor) changeStudyIn.dfBadColor = config.badColor;
                    if (config.worstColor) changeStudyIn.dfWorstColor = config.worstColor;
    
                    if (config.refValues) {
                        changeStudyIn.dfUpperReferenceValue = config.refValues.max;
                        changeStudyIn.dfLowerReferenceValue = config.refValues.min;
                    }
    
                    if (config.goodColor || config.badColor || config.worstColor || config.refValues) {
                        // Handle color changes
                        this.setState({ changeStudy: changeStudyIn });
                    }
    
                }}
                reverseValues={false}
                goodColor={this.state.changeStudy.dfGoodColor || "var(--newDolphin)"}
                badColor={this.state.changeStudy.dfBadColor || "var(--newDolphin)"}
                worstColor={this.state.changeStudy.dfWorstColor || "var(--newDolphin)"}
                goodClass="tile-greenlight"
                badClass="tile-yellowlight"
                worstClass="tile-redlight"
                overridename="procedures-gauge"
                sizeFactor={1}
            />
            <GaugeTile
                ref={this.BFGaugeRef}
                title="BF"
                value={gaugeRangesBF.goodRange.max + gaugeRangesBF.badRange.min / 2} // Example value
                context="Dashboard"
                enableColouring={true}
                valueStale={false}
                subValue={0}
                subValueUom=""
                uom="%"
                includeSubValue={false}
                defaultColor="tile-no-data"
                maxValue={1000}
                includeEdit={false}
                setRefValueMode={true}
                {...gaugeRangesBF}
                wideTile={false}
                expanded={true}
                referenceValueStyle="Bar"
                tileClicked={() => { console.log('Tile clicked') }}
                tileValueChanged={() => {
                    console.log('Value changed')
                }}
                onConfigChanged={(config) => {
                    let changeStudyIn = { ...this.state.changeStudy };
                    if (config.goodColor) changeStudyIn.bfGoodColor = config.goodColor;
                    if (config.badColor) changeStudyIn.bfBadColor = config.badColor;
                    if (config.worstColor) changeStudyIn.bfWorstColor = config.worstColor;
    
                    if (config.refValues) {
                        changeStudyIn.bfUpperReferenceValue = config.refValues.max;
                        changeStudyIn.bfLowerReferenceValue = config.refValues.min;
                    }
    
                    if (config.goodColor || config.badColor || config.worstColor || config.refValues) {
                        // Handle color changes
                        this.setState({ changeStudy: changeStudyIn });
                    }
    
                }}
                reverseValues={false}
                goodColor={this.state.changeStudy.bfGoodColor || "var(--newDolphin)"}
                badColor={this.state.changeStudy.bfBadColor || "var(--newDolphin)"}
                worstColor={this.state.changeStudy.bfWorstColor || "var(--newDolphin)"}
                goodClass="tile-greenlight"
                badClass="tile-yellowlight"
                worstClass="tile-redlight"
                overridename="procedures-gauge"
                sizeFactor={1}
            />
            <GaugeTile
                ref={this.PIGaugeRef}
                title="PI"
                value={gaugeRangesPI.goodRange.max + gaugeRangesPI.badRange.min / 2}
                context="Dashboard"
                enableColouring={true}
                valueStale={false}
                subValue={0}
                subValueUom=""
                uom=" "
                includeSubValue={false}
                defaultColor="tile-no-data"
                maxValue={1000}
                includeEdit={false}
                setRefValueMode={true}
                {...gaugeRangesPI}
                wideTile={false}
                expanded={true}
                referenceValueStyle="Bar"
                tileClicked={() => { console.log('Tile clicked') }}
                tileValueChanged={() => {
                    console.log('Value changed')
                }}
                onConfigChanged={(config) => {
                    let changeStudyIn = { ...this.state.changeStudy }; // Create a copy
                    if (config.goodColor) changeStudyIn.piGoodColor = config.goodColor;
                    if (config.badColor) changeStudyIn.piBadColor = config.badColor;
                    if (config.worstColor) changeStudyIn.piWorstColor = config.worstColor;
    
                    if (config.refValues) {
                        changeStudyIn.piUpperReferenceValue = config.refValues.max;
                        changeStudyIn.piLowerReferenceValue = config.refValues.min;
                    }
    
                    if (config.goodColor || config.badColor || config.worstColor || config.refValues) {
                        this.setState({ changeStudy: changeStudyIn });
                    }
                }}            reverseValues={false}
                goodColor={this.state.changeStudy.piGoodColor || "var(--newDolphin)"}
                badColor={this.state.changeStudy.piBadColor || "var(--newDolphin)"}
                worstColor={this.state.changeStudy.piWorstColor || "var(--newDolphin)"}
                goodClass="tile-greenlight"
                badClass="tile-yellowlight"
                worstClass="tile-redlight"
                overridename="procedures-gauge"
                sizeFactor={1}
            />
            <GaugeTile 
                ref={this.MEANGaugeRef}
                title="MEAN" 
                value={gaugeRangesMEAN.goodRange.max+gaugeRangesMEAN.badRange.min/2}
                context="Dashboard"
                enableColouring={true}
                valueStale={false}
                subValue={0}
                subValueUom=""
                uom="mL/min"
                includeSubValue={false}
                defaultColor="tile-no-data"
                maxValue={1000}
                includeEdit={false}
                setRefValueMode={true}
                {...gaugeRangesMEAN}
                wideTile={false}
                expanded={true}
                referenceValueStyle="Bar"
                tileClicked={() => { console.log('Tile clicked') }}
                tileValueChanged={() => {
                    console.log('Value changed')
                }}
                onConfigChanged={(config) => { 
                    let changeStudyIn = { ...this.state.changeStudy }; 
                    if (config.goodColor) changeStudyIn.meanGoodColor = config.goodColor;
                    if (config.badColor) changeStudyIn.meanBadColor = config.badColor;
                    if (config.worstColor) changeStudyIn.meanWorstColor = config.worstColor;

                    if (config.refValues)
                    {
                        changeStudyIn.upperReferenceValue = config.refValues.max;
                        changeStudyIn.lowerReferenceValue = config.refValues.min;
                    }

                    if (config.goodColor || config.badColor || config.worstColor || config.refValues) {
                    // Handle color changes
                    this.setState({ changeStudy: changeStudyIn });
                    }
                    
                }}
                reverseValues={false}
                goodColor={this.state.changeStudy.meanGoodColor || "var(--newDolphin)"}
                badColor={this.state.changeStudy.meanBadColor || "var(--newDolphin)"}
                worstColor={this.state.changeStudy.meanWorstColor || "var(--newDolphin)"}
                goodClass="tile-greenlight"
                badClass="tile-yellowlight"
                worstClass="tile-redlight"
                overridename="procedures-gauge"
                sizeFactor={1}
            />
            <GaugeTile 
                ref={this.ACIGaugeRef}
                title="ACI" 
                value={gaugeRangesACI.goodRange.max+gaugeRangesACI.badRange.min/2}
                context="Dashboard"
                enableColouring={true}
                valueStale={false}
                subValue={0}
                subValueUom=""
                uom="%"
                includeSubValue={false}
                defaultColor="tile-no-data"
                maxValue={1000}
                includeEdit={false}
                setRefValueMode={true}
                {...gaugeRangesACI}
                wideTile={false}
                expanded={true}
                referenceValueStyle="Bar"
                tileClicked={() => { console.log('Tile clicked') }}
                tileValueChanged={() => {
                    console.log('Value changed')
                }}
                onConfigChanged={(config) => { 
                    let changeStudyIn = { ...this.state.changeStudy }; 
                    if (config.goodColor) changeStudyIn.aciGoodColor = config.goodColor;
                    if (config.badColor) changeStudyIn.aciBadColor = config.badColor;
                    if (config.worstColor) changeStudyIn.aciWorstColor = config.worstColor;

                    if (config.refValues)
                    {
                        changeStudyIn.aciUpperReferenceValue = config.refValues.max;
                        changeStudyIn.aciLowerReferenceValue = config.refValues.min;
                    }

                    if (config.goodColor || config.badColor || config.worstColor || config.refValues) {
                    // Handle color changes
                    this.setState({ changeStudy: changeStudyIn });
                    }
                    
                }}
                reverseValues={false}
                goodColor={this.state.changeStudy.aciGoodColor || "var(--newDolphin)"}
                badColor={this.state.changeStudy.aciBadColor || "var(--newDolphin)"}
                worstColor={this.state.changeStudy.aciWorstColor || "var(--newDolphin)"}
                goodClass="tile-greenlight"
                badClass="tile-yellowlight"
                worstClass="tile-redlight"
                overridename="procedures-gauge"
                sizeFactor={1}
            />
       
    </CollapsibleSection>

        let protocolform =
            <div className="protocolform">
                <div className="protocolformHeader">
                    <h2 className="protocolformTitle">Protocol</h2>
                    <button className="addOrRemoveButton" onClick={() => {
                                    let newStudy1 = this.state.changeStudy;
                                    if (!newStudy1.protocolSteps) { newStudy1.protocolSteps = [] }
                                    newStudy1.protocolSteps?.push(""); 
                                    this.setState({ changeStudy: newStudy1 });
                                }}><PiPlus className="buttonIcon"/></button>
                </div>
                <div className="protocolformBody">
                    {
                        this.state.changeStudy.protocolSteps?.map((value, index: number) => {
                            return <div className="newStep">
                                    <InputItem type="text" title={"Step " + (index + 1)} name={"step" + (index + 1)} value={value} onChange={(name, value1) => {
                                    let newStudy1 = this.state.changeStudy;
                                    (newStudy1.protocolSteps as string[])[index] = value1;
                                    this.setState({ changeStudy: newStudy1 });
                                    }}></InputItem>

                                    <button className="menuButton" onClick={() => {
                                    let newStudy1 = this.state.changeStudy;
                                    if (!newStudy1.protocolSteps) { newStudy1.protocolSteps = [] }
                                    (newStudy1.protocolSteps as string[]).splice(index,1);  
                                    this.setState({ changeStudy: newStudy1 });
                                    }}><PiTrash className="buttonIcon"/></button>
                                </div>
                        })
                    }
                </div>
            </div>
        let addLabelTypes =
        <div className="protocolform">
            <div className="protocolformHeader">
                <h2 className="protocolformTitle">Label Types</h2>
                <button className="addOrRemoveButton" onClick={() => {
                                let newStudy1 = this.state.changeStudy;
                                if (!newStudy1.labelTypes) { newStudy1.labelTypes = [] }
                                newStudy1.labelTypes?.push(""); 
                                this.setState({ changeStudy: newStudy1 });
                            }}><PiPlus className="buttonIcon"/></button>
            </div>
            <div className="protocolformBody">
                {
                    this.state.changeStudy.labelTypes?.map((value, index: number) => {
                        return <div className="newStep">
                                <InputItem type="text" title={"Type " + (index + 1)} name={"type" + (index + 1)} value={value} onChange={(name, value1) => {
                                let newStudy1 = this.state.changeStudy;
                                (newStudy1.labelTypes as string[])[index] = value1;
                                this.setState({ changeStudy: newStudy1 });
                                }}></InputItem>

                                <button className="menuButton" onClick={() => {
                                let newStudy1 = this.state.changeStudy;
                                if (!newStudy1.labelTypes) { newStudy1.labelTypes = [] }
                                (newStudy1.labelTypes as string[]).splice(index,1);  
                                this.setState({ changeStudy: newStudy1 });
                                }}><PiTrash className="buttonIcon"/></button>
                            </div>
                    })
                }
            </div>
        </div>
        
        
        let suggestedlabels =
        <div className="protocolform">
            <div className="protocolformHeader">
                <h2 className="protocolformTitle">Suggested Labels</h2>
                <button className="addOrRemoveButton" onClick={() => {
                                let newStudy1 = this.state.changeStudy;
                                if (!newStudy1.suggestedLabels) { newStudy1.suggestedLabels = [] }
                                newStudy1.suggestedLabels?.push({index:0, name:"", description:"", type:""}); 
                                this.setState({ changeStudy: newStudy1 });
                            }}><PiPlus className="buttonIcon"/></button>
            </div>
            <div className="protocolformBody">
               {this.state.changeStudy.suggestedLabels && this.state.changeStudy.suggestedLabels.length>0?<div className="newStepHeader">
                                    <div className="labelgridName">Name</div>
                                    <div className="labelgridDesc">Description</div>
                                    <div className="labelgridType">Type</div>
              </div> :<></>} 
            
                {this.state.changeStudy.suggestedLabels?.map((value, index: number) => {
                        let labelTypeoptions: string[]= ["--Select--"];
                        this.state.changeStudy.labelTypes?.forEach(type => labelTypeoptions.push(type));
                        
                        return <div className="newStep"> 
                                <div className="newStepContainer">
                                <div className="newStepInputs">
                                    <div className="labelName">
                                        
                                        <InputItem type="text" title={"Label " + (index + 1)} name={"labelName" + (index + 1)} value={value.name} onChange={(name, value1) => {
                                        let newStudy1 = this.state.changeStudy;
                                        (newStudy1.suggestedLabels as LabelModel[])[index].name = value1;
                                        (newStudy1.suggestedLabels as LabelModel[])[index].id = value1;
                                        this.setState({ changeStudy: newStudy1 });
                                        }}></InputItem>
                                    </div>
                                    <div className="labeldesc">
                                        <InputItem type="text" title={""} name={"labelDescription" + (index + 1)} value={value.description} onChange={(name, value1) => {
                                        let newStudy1 = this.state.changeStudy;
                                        (newStudy1.suggestedLabels as LabelModel[])[index].description = value1;
                                        this.setState({ changeStudy: newStudy1 });
                                        }}></InputItem>
                                    </div>  
                                    
                                    <div className="labelType">
                                        
                                        <InputItem type="dropdown" title={""} name={"labelType" + (index + 1)} value={value.type? value.type: labelTypeoptions[0]} options={labelTypeoptions} onChange={(name, value1) => {
                                        let newStudy1 = this.state.changeStudy;
                                        (newStudy1.suggestedLabels as LabelModel[])[index].type = value1;
                                        this.setState({ changeStudy: newStudy1 });
                                        }}></InputItem>
                                    </div> 
                                    
                                    <button className="menuButton" onClick={() => {
                                    let newStudy1 = this.state.changeStudy;
                                    if (!newStudy1.suggestedLabels) { newStudy1.suggestedLabels = [] }
                                    (newStudy1.suggestedLabels as LabelModel[]).splice(index,1);  
                                    this.setState({ changeStudy: newStudy1 });
                                    }}><PiTrash className="buttonIcon"/></button>
                                </div>
                            </div>
                            </div>
                    })
                }
            </div>
        </div>

        let studyoptions: string[]= this.props.studies.map((study) => (study.name));
        studyoptions.splice(0,0,"Add New Study");
        

        return (
            <>

                <div className="addStudyContainer">
                    <div className="addStudyHeader">
                        <div className="studyDropdownContainer">
                            <InputItem type="dropdown" title={"Edit or add a study"} name="studiesDropdown" onChange={this.onDropdownChanged} value={(this.props.selectedStudy.name ?this.props.selectedStudy.name: studyoptions.at(0))} options={studyoptions}/>
                        </div>
                    </div>
                    <div className="addStudyBody">
                        <div className="leftContainer">
                            <h2 className="studyformHeader">Study Information</h2>
                            <div className="inputItems">
                                <InputItem type="text" title={"Name"} name={"name"} onChange={this.onInputItemchanged} value={this.state.changeStudy.name}></InputItem>
                                <InputItem type="date" title={"Startdate"} name={"startdate"} onChange={this.onInputItemchanged} value={this.state.changeStudy.startdate}></InputItem>
                                <InputItem type="number" title={"Expected Procedures"} name={"expectedProcedures"} onChange={this.onInputItemchanged} value={this.state.changeStudy.expectedProcedures}></InputItem>
                                <InputItem type="number" title={"Expected Hospitals"} name={"expectedHospitals"} onChange={this.onInputItemchanged} value={this.state.changeStudy.expectedHospitals}></InputItem>

                                <InputItem type="longtext" title={"Description"} name={"description"} onChange={this.onInputItemchanged} value={this.state.changeStudy.description}></InputItem>
                                <InputItem type="dropdown" title={"Study Type"} name={"studyType"} onChange={this.onInputItemchanged} value={this.state.changeStudy.studyType} options={studyTypeOptions} key={`studyType-dropdown-${this.state.changeStudy.id}`}></InputItem>
                                <InputItem type="dropdown" title={"Default view"} name={"defaultView"} onChange={this.onInputItemchanged} value={this.state.changeStudy.defaultView} options={["Intui", "Legacy"]} key={`defaultView-dropdown-${this.state.changeStudy.id}`}></InputItem>
                                
                                {/* <div className="referenceValues"> 
                                    <div className="referenceValuesTitle">Mean Flow Reference Values</div>
                                    <InputItem type="number" title={"Lower Value"} name={"lowerReferenceValue"} onChange={this.onInputItemchanged} value={this.state.changeStudy.MEANlowerReferenceValue}></InputItem>
                                    <InputItem type="number" title={"Upper Value"} name={"upperReferenceValue"} onChange={this.onInputItemchanged} value={this.state.changeStudy.MEANupperReferenceValue}></InputItem>
                                </div> */}
                                <div className="advancedSettings"> 
                                    <div className="advancedSettingsTitle" onClick={()=>{
                                        this.setState({
                                            advancedSettingsOpen: !this.state.advancedSettingsOpen
                                        })
                                    }}> <h2>Advanced Settings</h2>
                                        <span className="accordionArrow">
                                            { this.state.advancedSettingsOpen ? <>&#9660;</> : <>&#9654;</>}
                                        </span>
                                    </div>
                                    <div className={"accordion-panel " + (this.state.advancedSettingsOpen ? "open" : "")}>
                                        <InputItem type="dropdown" title={"Select ID Column"} name={"idFieldForStudy"} onChange={this.onInputItemchanged} value={this.state.changeStudy.idFieldForStudy || this.props.idOptions[0]} options={this.props.idOptions} key={`id-dropdown-${this.state.changeStudy.id}`}></InputItem>
                                        <InputItem type="checkbox" title={"Allow Personal Data"} name={"allowPersonalData"} onChange={this.onInputItemchanged} value={this.state.changeStudy.allowPersonalData}></InputItem>
                                        <InputItem type="checkbox" title={"Allow Full Date Only"} name={"allowFullDateOnly"} onChange={this.onInputItemchanged} value={this.state.changeStudy.allowFullDateOnly}></InputItem>
                                        {this.state.changeStudy.allowPersonalData &&
                                            <InputItem type="checkbox" title={"Encryption Enabled"} name={"encryptionEnabled"} onChange={this.onInputItemchanged} value={this.state.changeStudy.encryptionEnabled}></InputItem>
                                        }
                                        <InputItem type="checkbox" title={"Export Enabled"} name={"exportEnabled"} onChange={this.onInputItemchanged} value={this.state.changeStudy.exportEnabled}></InputItem>
                                        <InputItem type="checkbox" title={"Include Surgeon"} name={"includeSurgeon"} onChange={this.onInputItemchanged} value={this.state.changeStudy.includeSurgeon}></InputItem>
                                        <InputItem type="checkbox" title={"Include Project"} name={"includeProject"} onChange={this.onInputItemchanged} value={this.state.changeStudy.includeProject}></InputItem>
                                        <InputItem type="checkbox" title={"Calculate BMI"} name={"calculateBMI"} onChange={this.onInputItemchanged} value={this.state.changeStudy.calculateBMI}></InputItem>
                                        <InputItem type="checkbox" title={"AI Curve Evaluation Enabled"} name={"curveEvalEnabled"} onChange={this.onInputItemchanged} value={this.state.changeStudy.curveEvalEnabled}></InputItem>
                                        <div className="referenceValues"> 

                                            {collapsableGaugeAdjust}
                               
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rightContainer">
                            <div className="workflowContainer">
                                <div className="workflowHeader">
                                    <h2>Workflow</h2>
                                </div>    
                                <div className="addWorkflow">
                                    <span>{(this.state.changeStudy.workflowFilename ? this.state.changeStudy.workflowFilename: "Add workflow") }</span>
                                    <button className="addOrRemoveButton" onClick={() => {
                                        (this.fileBrowserMulti.current as MultiFileBrowser).openDialog();
                                    }} ><PiPlus className="buttonIcon"/></button>

                                </div>
                            </div>
                            {protocolform}
                            {addLabelTypes}
                            {suggestedlabels}
                            
                        </div>



                    </div>
                    <div className="addStudyFooter">
                        <button className="primaryButton" onClick={() => {
                            this.props.dataClient.CallSettingsService("SaveNewStudy", this.state.changeStudy, {}, (outputValue: string) => 
                            {   
                                if (outputValue)
                                {
                                    let toShow = JSON.parse(outputValue);
                                    if (toShow === "DONE")
                                        this.state.changeStudy.id === "-1" ? (this.infoBox.current as InfoBox).show("Study successfully added") : (this.infoBox.current as InfoBox).show("Study updated") 
                                    else
                                        (this.errorWindow.current as ErrorWindow).show(700, toShow);
                                }else
                              {
                                (this.errorWindow.current as ErrorWindow).show(700, outputValue);
                              }

                            },  (stautus:number, errorMessage:string)=>{ (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage)},"POST");

                        }}>{this.state.changeStudy.id === "-1" ? "Create" : "Save"}</button>
                    </div>
                    <InfoBox ref={this.infoBox} title="Confirmation" type="confirmation"></InfoBox>
                    <MultiFileBrowser ref={this.fileBrowserMulti} singleFileInput={true} performUpload={true} methodName={"ProcessWorkflowFile"} controllerName={"Settings"} dataTransfer={this.props.dataClient} progressEvent={() => { }} onUploadComplete={this.onUploadConfirmed} onUploadFailed={(status: number, errorText: string, statusText: string) =>{ 
                    if (this.errorWindow.current as ErrorWindow)
                        (this.errorWindow.current as ErrorWindow).show(status, errorText, statusText, "File upload failed")
                }}></MultiFileBrowser>
                    <ErrorWindow ref={this.errorWindow}></ErrorWindow>
                </div>

            </>
        );
    }
}
